
const map = new Map([
['general.error', 'Error: '],
['general.server.status.error', 'The server responded with a status of  '],
['general.info.search.empty', 'Total number of items is 0.'],
['general.info.title', 'Information'],
['general.error.endDate', 'End Date is before Start Date'],

['login.username.error', 'User Name is required.'],
['login.password.error', 'Password is required.'],
['login.realm.error', 'Realm is required.'],
['login.oldpassword.error', 'Old Password is required.'],
['login.newpassword.error', 'New Password is required.'],
['login.confirmpassword.error', 'Confirm Password is required.'],
['login.passwordNotMatch.error', 'New and Confirm Passwords do not match.'],
['login.passwordLength.error', 'New Password must be at least 8 characters.'],
['login.activationKey.error', 'Activation Key is required.'],

['createAccount.transit.error', 'Transit Number is required.'],
['createAccount.account.error', 'Account Number is required.'],
['createAccount.checkbox.error', 'Checkbox is not checked.'],

['stopPayment.checkNumber.error', 'Check Number is required.'],
['stopPayment.amount.error', 'Amount is required.'],
['stopPayment.checkDate.error', 'Check Date is required.'],

['disposition.payee.error', 'Payee is required.'],
['disposition.reason.error', 'Return Reason is required.'],
['revalidation.authCode.error', 'Authentication Code is required.'],

['upload.checkNumber.outofrange.error', 'Check Number is out of range.'],

['ach.policy.effective.date.error', 'Effective Date is required.'],
['ach.policy.description.error', 'Description is required.'],
['ach.policy.expiry.date.error', 'Expiry Date is before Effective Date.'],

['deposit.location.error', 'Deposit Location is required.'],
['deposit.location.name.error', 'Location Name is required.'],

['company.name.error', 'Company Name is required.'],
['company.contact.error', 'Contact Name is required.'],
['company.phone.error', 'Phone Number is required.'],
['company.fax.error', 'Fax Number is required.'],
['company.email.error', 'E-mail is required.'],

['user.login.id.error', 'Login ID must be minimum 5 characters.'],
['user.username.error', 'User Name is required.'],

['search.checkNumberStart.error', 'Check Number start is required.'],
['search.checkNumberEnd.error', 'Check Number end is required.'],
['search.checkNumberRange.error', 'Maximum check number range exceeded.'],
['search.checkNumberRangeValid.error', 'Maximum check number should be higher than minimum check number.'],
['search.amountRange.error', 'Maximum amount should be higher than minimum amount.'],

['decision.bulk.error', 'Bulk decisions are not allowed on pending items. Please decision any pending items.'],
]);

// add French map
//const frenchMap = new Map();

export function getErrorString(key,defValue){
	if (getMap().has(key)){
		return map.get(key);
	}
	else{
		return defValue;
	}
}

function getMap(){

  var myMap = map;
  //uncomment below  code for French
  /*
  var language = window.navigator.userLanguage || window.navigator.language;
  if (language){
	if (language.indexOf('fr') !== -1){
		if (frenchMap.size > 0){
			myMap = frenchMap;
		}
	}
  }
  */
  return myMap;

}